export const square = {
  nodes: [
    {
      id: "1",
      position: "0,0",
      data: {
        shortestPath: 0,
        predecessorId: "0",
      },
    },
    {
      id: "2",
      position: "100,0",
      data: {},
    },
    {
      id: "3",
      position: "100,100",
      data: {},
    },
    {
      id: "4",
      position: "0,100",
      data: {},
    },
    {
      id: "5",
      position: "-100,200",
      data: {},
    },
  ],
  edges: [
    {
      id: "e1-2",
      source: "1",
      target: "2",
      sourceHandle: "handle-right",
      targetHandle: "handle-left",
      label: "1",
      data: {},
    },
    {
      id: "e1-4",
      source: "1",
      target: "4",
      sourceHandle: "handle-bottom",
      targetHandle: "handle-top",
      label: "2",
      data: {},
    },
    {
      id: "e2-3",
      source: "2",
      target: "3",
      sourceHandle: "handle-bottom",
      targetHandle: "handle-top",
      label: "1",
      data: {},
    },
    {
      id: "e3-4",
      source: "3",
      target: "4",
      sourceHandle: "handle-left",
      targetHandle: "handle-right",
      label: "1",
      data: {},
    },
    {
      id: "e4-5",
      source: "4",
      target: "5",
      sourceHandle: "handle-bottom",
      targetHandle: "handle-top",
      label: "10",
      data: {},
    },
  ],
};

export const pentagon = {
  nodes: [
    {
      id: "1",
      position: "100,0",
      data: {
        shortestPath: 0,
        predecessorId: "0",
      },
    },
    {
      id: "2",
      position: "0,150",
      data: {},
    },
    {
      id: "3",
      position: "200,150",
      data: {},
    },
    {
      id: "4",
      position: "0,300",
      data: {},
    },
    {
      id: "5",
      position: "200,300",
      data: {},
    },
  ],
  edges: [
    {
      id: "e1-2",
      source: "1",
      target: "2",
      sourceHandle: "handle-left",
      targetHandle: "handle-top",
      label: "1",
      data: {},
    },
    {
      id: "e1-3",
      source: "1",
      target: "3",
      sourceHandle: "handle-right",
      targetHandle: "handle-top",
      label: "2",
      data: {},
    },
    {
      id: "e2-4",
      source: "2",
      target: "4",
      sourceHandle: "handle-bottom",
      targetHandle: "handle-top",
      label: "100",
      data: {},
    },
    {
      id: "e3-5",
      source: "3",
      target: "5",
      sourceHandle: "handle-bottom",
      targetHandle: "handle-top",
      label: "1",
      data: {},
    },
    {
      id: "e4-5",
      source: "4",
      target: "5",
      sourceHandle: "handle-right",
      targetHandle: "handle-left",
      label: "200",
      data: {},
    },
  ],
};
